import store from '@/store'

export default function redirectBasedOnRole() {
    const { hasRole, organization, auth } = store.getters

    let route = { name: 'logout', replace: true }

    if (auth) {
        if (hasRole('super_admin') || hasRole('support_admin') || hasRole('developer')) {
            route = { path: '/organizations', replace: true }
        }

        if (hasRole('logistics_manager')) {
            route = { path: '/radios/summary', replace: true }
        }

        if (hasRole('admin') || hasRole('field_user') || hasRole('mission_control_user')) {
            route = { path: `/${organization.slug}/dashboard`, replace: true }
        }
    }

    return route
}
